export const Buckets = {
  MEDIA: "piperunner-cms-media",
};

export const FolderNames = {
  IMAGES: "images",
};
